module.exports = __webpack_public_path__ + "img/new-fw.d090fea.png";